import React, { useEffect, useState } from 'react'
import { Col, Menu, MenuProps, Popover, Row, Space } from 'antd';

import styles from './sider.module.scss';
import { useRedux } from 'redux/useRedux';
import { onChangePublic } from 'redux/actions/public';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'contexts/auth-context';
import { useContext } from 'react';
import { statusSubscription, tree_digit_number } from 'utils/globalFunction';
import { AIIcon, AnalysisIcon, BasketIcon, ChangeIcon, ChartIcon, CircleLogoIcon, HomeIcon, InfoIcon, InquiryIcon, LogoutIcon, MewsIcon, NotificationIcon, SettingIcon, SignalIcon, SupportIcon, Tick2Icon, Tick3Icon, UserIcon } from 'assets/svgComponent';
import { getInfoAction } from 'page/dashboard/account/redux/actions';
const SiderComponent = () => {
    const ctx = useContext(AuthContext);
    type MenuItem = Required<MenuProps>['items'][number];
    const { publicState, dispatch, authState,accountState } = useRedux()

    console.log(ctx.user)
    useEffect(() => {
        if(!accountState.allInfoUser?.userInfo)
         dispatch(getInfoAction(ctx.user.id))
    }, [])
    const navigate = useNavigate()
    const items: MenuItem[] = [
        getItem('داشبورد', 'dashboard', <HomeIcon />,),
        getItem('حساب کاربری', 'account', <UserIcon />,),
        // getItem('چارت ها', 'stock', <ChartIcon />,),
        // getItem('سبد پیشنهادی', 'signal', <SignalIcon />,),
        getItem('تحلیل ها', 'analysis', <AnalysisIcon />,),
        // getItem('اخبار', 'sub5', <MewsIcon />,),
        getItem('خرید اشتراک', 'basket', <BasketIcon />,),
        getItem('پشتیبانی', 'support', <SupportIcon />,),
        getItem('تست ریسک‌پذیری', 'risk', <Tick3Icon />,),
        getItem('استعلام', 'inquiry', <InquiryIcon />,
        [
            getItem('تسهیلات', 'facility'),
            // getItem('چک برگشتی', 'backCheques'),
            getItem('خلافی', 'drivingOffense'),
            // getItem('اعتبار سنجی', '8'),
        ]
        ),
        getItem('انواع تبدیل ها', 'transformation', <ChangeIcon />,),
        getItem('چت هوش مصنوعی', 'aiChat', <AIIcon />,),
    ];
    function getItem(
        label: React.ReactNode,
        key: React.Key,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }
    return (

        <div id={!publicState?.sider_open ? 'sider_open' : 'sider_close'} className={`fullWidth  ${!publicState?.sider_open ? styles.closeSider : styles.openSider}  `} >
            <Row  onClick={()=>{window. open("https://www.investo.ir", "_blank")}} justify={"center"} className={"fullWidth"} >
                <CircleLogoIcon />
            </Row>
            {publicState?.sider_open && <Row justify={"start"} align={"middle"} className={"fullWidth mt20 mb20 profileDiv"} >
                <div className={styles.profile}>
                    <UserIcon />
                </div>
                <Col>
                    <p className='t2 white100 ms20 '>{ctx.user?.first_name} {ctx.user?.last_name}</p>
                    {/* <p className='t5 ' style={{ color: "yellow" }}>کاربر {statusSubscription(ctx)}</p> */}
                </Col>
                {/* <SettingIcon className={styles.settingIcon} /> */}
            </Row>}

            <Menu
                mode="inline"
                defaultActiveFirst
                className={'my_menu'}
                selectedKeys={[publicState?.menuId]}
                items={items}
               
                theme="dark"
            
                // inlineCollapsed={true}
                // getPopupContainer={function test(node) {
                //     return node.parentNode as HTMLElement;
                //   }}
                onClick={(item) => {
                    // if (ctx?.user?.risk_points) {
                        dispatch(onChangePublic("menuId", item.key))
                        switch (item.key) {
                            case "dashboard":
                                navigate({ pathname: "/dashboard" })
                                break;
                            case "account":
                                navigate({ pathname: "/account" })
                                break;
                            case "analysis":
                                navigate({ pathname: "/analysis" })
                                break;
                            case "basket":
                                navigate({ pathname: "/basket" })
                                break;
                            // case "signal":
                            //     navigate({ pathname: "/signal" })
                            //     break;
                            case "support":
                                navigate({ pathname: "/support" })
                                break;
                            case "stock":
                                navigate({ pathname: "/stock" })
                                break;
                            case "risk":
                                navigate({ pathname: "/risk" })
                                break;
                            case "facility":
                                navigate({ pathname: "/inquiry/facility" })
                                break;
                            case "backCheques":
                                navigate({ pathname: "/inquiry/backCheques" })
                                break;
                            case "drivingOffense":
                                navigate({ pathname: "/inquiry/drivingOffense" })
                                break;
                            case "transformation":
                                navigate({ pathname: "/transformation" })
                                break;
                            case "aiChat":
                                navigate({ pathname: "/aiChat" })
                                break;

                            default:
                                break;
                        }
                        dispatch(onChangePublic("drawer_open", false))
                    // }

                }

                }
            />
            {/* <div style={{ height: 40 }} /> */}

            <Row onClick={() => ctx.handleLogout()} className={[styles.logout, 'pointer'].join(" ")} style={{marginInlineStart:publicState?.sider_open?0:15}}>
                <LogoutIcon />
                {publicState?.sider_open && <span>خروج</span>}
            </Row>

        </div>


    )
}


export default SiderComponent
